module.exports = __webpack_public_path__ + "static/3-417bddb860a9e628fc174c2608564b53.jpg";